<template>
  <v-container>
    <v-row align="center">
      <v-col
        v-for="(link, i) in links"
        :key="i"
        class="text-center"
        cols="6"
        md="auto"
      >
        <a
          :href="link.href"
          class="text-decoration-none text-uppercase text-caption font-weight-regular"
          rel="noopener"
          target="_blank"
          v-text="link.text"
        />
      </v-col>

      <v-spacer class="hidden-sm-and-down" />

      <v-col
        cols="12"
        md="auto"
      >
        <!-- <div class="text-body-1 font-weight-light pt-8 pt-md-10 text-left">
          &copy; {{ (new Date()).getFullYear() }}, Made by <v-img
            height="20"
            width="20"
            src="https://assets.conductor.systems/conductor-logo.png"
          /><a
            href="https://conductorsystems.com"
            class="text-decoration-none"
          >Conductor Systems</a>
        </div> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Links',

    data: () => ({
      links: [
        // {
        //   href: 'https://vuetifyjs.com/',
        //   text: 'Vuetify Docs',
        // },
        // {
        //   href: '#',
        //   text: 'About Us',
        // },
        // {
        //   href: '#',
        //   text: 'Blog',
        // },
        // {
        //   href: '#',
        //   text: 'Licenses',
        // },
      ],
    }),
  }
</script>

<style lang="sass" scoped>
  a
    color: inherit !important
</style>
